<!-- 同城快修地址 -->
<template>
  <div class="address-location">
    <vanPopup
      v-model="showPopup"
      position="bottom"
      :round="true"
      :lock-scroll="false"
      @click-overlay="closePopup"
      v-backFn="{ show: showPopup, closeFn: 'closePopup' }"
    >
      <div class="popup-wrap">
        <div class="popup-head">
          <div class="popup-title">
            {{ isSameAddress ? '添加上门取件地址' : '添加修后寄返地址' }}
          </div>
          <div class="popup-close" @click="closePopup"></div>
        </div>
        <div class="popup-content">
          <div class="address-list">
            <div :class="['address-list-item os-font-14-400', { isError: nameError }]">
              <div class="item-title os-font-15-400">
                {{ isSameAddress ? `${repairType == 6 ? '姓名' : '寄件人'}` : '收货人' }}
              </div>
              <div class="input-container">
                <input
                  ref="receiverName"
                  v-model="addressInfo.receiverName"
                  maxlength="20"
                  :placeholder="
                    isSameAddress
                      ? `请填写${repairType == 6 ? '' : '寄件人'}姓名`
                      : '请填写收件人姓名'
                  "
                  type="text"
                />
              </div>
            </div>
            <div
              :class="[
                'address-list-item item-space os-font-14-400',
                { isFocus: phoneFocus, isError: phoneError }
              ]"
            >
              <div class="item-title os-font-15-400">手机号码</div>
              <div class="input-container">
                <input
                  ref="mobilePhone"
                  type="tel"
                  maxlength="11"
                  v-model="addressInfo.mobilePhone"
                  :placeholder="
                    isSameAddress
                      ? `请填写${repairType == 6 ? '' : '寄件人'}手机号码`
                      : '请填写收件人手机号码'
                  "
                />
              </div>
            </div>
            <div
              :class="['address-list-item item-space os-font-14-400', { isError: areaError }]"
              @click="selectProvince"
            >
              <div class="item-title os-font-15-400">所在地区</div>
              <div class="input-container">
                <input
                  ref="areaContainer"
                  readonly
                  v-model="currentProvinceAddress"
                  placeholder="省市区县、乡镇等"
                  type="text"
                />
              </div>
            </div>
            <div
              :class="[
                'address-list-item detail-area item-space os-font-14-400',
                { isError: detailAddressError }
              ]"
              @click="goLocation"
            >
              <div class="item-title os-font-15-400">详细地址</div>
              <div class="input-container">
                <input
                  ref="detailAddress"
                  v-model="currentProvinceDetialAddress"
                  maxlength="50"
                  readonly
                  placeholder="请搜索详细地址"
                  type="text"
                />
              </div>
              <div class="location-detail"></div>
            </div>
            <div class="address-list-item item-space-bottom item-space os-font-14-400">
              <div class="item-title os-font-15-400">门牌号</div>
              <div class="input-container">
                <input
                  v-model="addressInfo.detailAddressNumber"
                  maxlength="50"
                  placeholder="请填写门牌号（选填）"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="popup-bottom" @click="selectConfirm">
          <div class="popup-button">{{ footerText }}</div>
        </div>
      </div>
    </vanPopup>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { isPhone } from 'utils/reg'
import toast from '@/utils/toast'

export default {
  name: 'addressLocation',
  props: {
    // 底部按钮文案
    footerText: {
      type: String,
      default: '确定'
    }
  },
  data() {
    return {
      showPopup: false,
      addressInfo: {
        receiverName: '',
        mobilePhone: '',
        detailAddressNumber: '',
        detailAddress: ''
      },
      phoneFocus: false,
      phoneError: false,
      nameError: false,
      areaError: false,
      detailAddressError: false
    }
  },
  computed: {
    ...mapState('repair', [
      'addressSelectType',
      'isSameAddress',
      'quickRepairSendAddressInfo',
      'quickRepairReceiveAddressInfo',
      'repairType'
    ]),
    currentDetailAddress() {
      if (this.addressSelectType == 1) {
        if (!this.quickRepairSendAddressInfo.mapLocationPickupAddress.province) {
          if (this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province) {
            return (
              this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province +
              this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.city +
              this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.area +
              this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.detailAddress
            )
          } else {
            return ''
          }
        }
        return (
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.province +
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.city +
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.area +
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.detailAddress
        )
      } else {
        if (
          !this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province &&
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.province
        ) {
          if (this.quickRepairSendAddressInfo.mapLocationPickupAddress.province) {
            return (
              this.quickRepairSendAddressInfo.mapLocationPickupAddress.province +
              this.quickRepairSendAddressInfo.mapLocationPickupAddress.city +
              this.quickRepairSendAddressInfo.mapLocationPickupAddress.area +
              this.quickRepairSendAddressInfo.mapLocationPickupAddress.detailAddress
            )
          } else {
            return ''
          }
        }
        return (
          this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province +
          this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.city +
          this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.area +
          this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.detailAddress
        )
      }
    },
    currentProvinceAddress() {
      if (this.addressSelectType == 1) {
        if (!this.quickRepairSendAddressInfo.mapLocationPickupAddress.province) {
          if (this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province) {
            return (
              this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province +
              ' ' +
              this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.city +
              ' ' +
              this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.area
            )
          } else {
            return ''
          }
        }
        return (
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.province +
          ' ' +
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.city +
          ' ' +
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.area
        )
      } else {
        if (!this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province) {
          if (this.quickRepairSendAddressInfo.mapLocationPickupAddress.province) {
            return (
              this.quickRepairSendAddressInfo.mapLocationPickupAddress.province +
              ' ' +
              this.quickRepairSendAddressInfo.mapLocationPickupAddress.city +
              ' ' +
              this.quickRepairSendAddressInfo.mapLocationPickupAddress.area
            )
          } else {
            return ''
          }
        }
        return (
          this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province +
          ' ' +
          this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.city +
          ' ' +
          this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.area
        )
      }
    },
    currentProvinceDetialAddress() {
      if (this.addressSelectType == 1) {
        if (!this.quickRepairSendAddressInfo.mapLocationPickupAddress.detailAddress) {
          if (this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.detailAddress) {
            return this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.detailAddress
          } else {
            return ''
          }
        }
        return this.quickRepairSendAddressInfo.mapLocationPickupAddress.detailAddress
      } else {
        if (!this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.detailAddress) {
          if (this.quickRepairSendAddressInfo.mapLocationPickupAddress.detailAddress) {
            return this.quickRepairSendAddressInfo.mapLocationPickupAddress.detailAddress
          } else {
            return ''
          }
        }
        return this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.detailAddress
      }
    }
  },
  methods: {
    ...mapMutations('repair', [
      'setQuickRepairSendAddressInfo',
      'setQuickRepairReceiveAddressInfo',
      'SET_PICKER_ADDRESS'
    ]),
    // 阻止页面滑动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }

      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }

      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    openPopup() {
      if (this.addressSelectType == 1) {
        this.setPickupAddress()
      } else {
        this.setReceiveAddress()
      }
      this.preventPageScroll()
      this.$nextTick(() => {
        this.showPopup = true
      })
    },
    setPickupAddress() {
      if (
        this.quickRepairSendAddressInfo.receiverName ||
        this.quickRepairSendAddressInfo.mobilePhone ||
        this.quickRepairSendAddressInfo.detailAddressNumber
      ) {
        this.addressInfo.receiverName = this.quickRepairSendAddressInfo.receiverName
        this.addressInfo.mobilePhone = this.quickRepairSendAddressInfo.mobilePhone
        this.addressInfo.detailAddressNumber = this.quickRepairSendAddressInfo.detailAddressNumber

        // 使用取件地址时，同步经纬度
        if (!this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.lng) {
          this.quickRepairReceiveAddressInfo.mapLocationPickupAddress =
            this.quickRepairSendAddressInfo.mapLocationPickupAddress
        }
      } else if (this.quickRepairReceiveAddressInfo.receiverName) {
        this.setReceiveAddress()
      }
    },
    setReceiveAddress() {
      if (
        this.quickRepairReceiveAddressInfo.receiverName ||
        this.quickRepairReceiveAddressInfo.mobilePhone ||
        this.quickRepairReceiveAddressInfo.detailAddressNumber
      ) {
        this.addressInfo.receiverName = this.quickRepairReceiveAddressInfo.receiverName
        this.addressInfo.mobilePhone = this.quickRepairReceiveAddressInfo.mobilePhone
        this.addressInfo.detailAddressNumber =
          this.quickRepairReceiveAddressInfo.detailAddressNumber
      } else if (this.quickRepairSendAddressInfo.receiverName) {
        this.setPickupAddress()
      }
    },
    mobilePhoneFocus() {
      this.$nextTick(() => {
        this.phoneFocus = true
        this.$refs.mobilePhone.focus()
      })
    },
    closePopup() {
      this.restorePageScroll()
      this.$nextTick(() => {
        this.phoneFocus = false
        this.showPopup = false
      })
    },
    selectProvince() {
      if (this.currentProvinceAddress) {
        if (this.addressSelectType == 1) {
          this.SET_PICKER_ADDRESS(this.quickRepairSendAddressInfo.mapLocationPickupAddress)
        } else {
          this.SET_PICKER_ADDRESS(this.quickRepairReceiveAddressInfo.mapLocationPickupAddress)
        }
      } else {
        this.SET_PICKER_ADDRESS({})
      }
      this.$emit('quickSelectArea')
    },
    goLocation() {
      this.$emit('mapLocation')
    },
    selectConfirm() {
      this.phoneError = false
      this.nameError = false
      this.areaError = false
      this.detailAddressError = false
      if (!this.addressInfo.receiverName?.trim()) {
        this.nameError = true
        this.$nextTick(() => {
          this.$refs.receiverName.focus()
        })
        return toast(this.isSameAddress ? '请填写寄件人姓名' : '请填写收件人姓名')
      }

      if (this.addressInfo.receiverName?.trim().length < 2) {
        this.nameError = true
        this.$nextTick(() => {
          this.$refs.receiverName.focus()
        })
        return toast(this.isSameAddress ? '寄件人姓名不能少于2个字符' : '收件人姓名不能少于2个字符')
      }

      if (!this.addressInfo.mobilePhone) {
        this.phoneError = true
        this.$nextTick(() => {
          this.$refs.mobilePhone.focus()
        })
        return toast('请输入手机号码')
      }

      if (!isPhone(this.addressInfo.mobilePhone)) {
        this.phoneError = true
        this.$nextTick(() => {
          this.$refs.mobilePhone.focus()
        })
        return toast('请正确填写手机号码')
      }
      if (!this.currentProvinceAddress.trim()) {
        this.areaError = true
        this.$nextTick(() => {
          this.$refs.areaContainer.focus()
        })
        return toast('请选择地区！')
      }
      if (!this.currentProvinceDetialAddress || !this.currentProvinceDetialAddress.trim()) {
        this.detailAddressError = true
        this.$nextTick(() => {
          this.$refs.detailAddress.focus()
        })
        return toast('请选择详细地址')
      }

      this.addressInfo.detailAddress =
        this.currentDetailAddress + this.addressInfo.detailAddressNumber
      if (this.addressSelectType == 1) {
        this.setQuickRepairSendAddressInfo(this.addressInfo)
      } else {
        this.setQuickRepairReceiveAddressInfo(this.addressInfo)
      }
      this.$emit('selectConfirm')
      this.closePopup()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/os3_font_include.scss';

.address-location {
  .popup-content {
    max-height: calc(90vh - 100px);
    height: 444px;
    box-sizing: border-box;
    overflow: hidden;

    .address-list {
      max-height: calc(90vh - 100px);
      position: relative;
      overflow-y: auto;
      padding: 12px 16px 78px;
      box-sizing: border-box;

      .address-list-item {
        position: relative;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .item-title {
          color: #000;
          width: 60px;
          margin-right: 8px;
        }

        .input-container {
          flex: 1;

          input {
            @include font-weight-two(14, 400);
            display: flex;
            align-items: center;
            padding: 0 0;
            width: 100%;
            border: 1px solid transparent;
            border-radius: 6px;
            box-sizing: border-box;
            background: #f9f9f9;
            color: #000;
            height: 36px;
            box-sizing: border-box;
            padding: 11px 10px;

            .vivo-dark-mode & {
              background-color: #282828;
            }

            &::placeholder {
              color: #aaa;
            }
          }
        }

        &.isFocus {
          input {
            border: 1px solid #415fff;
            border-radius: 6px;
            box-sizing: border-box;
          }
        }

        &.isError {
          input {
            border: 1px solid rgba(241, 3, 19, 1);
            border-radius: 6px;
            box-sizing: border-box;
          }
        }

        &.detail-area {
          input {
            padding: 11px 35px 11px 10px;
          }
        }

        .location-detail {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 12px;
          width: 24px;
          height: 24px;
          background: url('~@/assets/img/repair/confirm/wap/map-icon.svg') center center no-repeat;
          background-size: contain;
        }
      }

      .item-space {
        margin-top: 14px;
      }

      .item-space-bottom {
        margin-bottom: 10px;
      }
    }

    .checkbox {
      margin-top: 33px;
    }
  }

  .popup-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #fff;

    .vivo-dark-mode & {
      background-color: #f7f7f7;
    }
  }
}
</style>
